import React, { useEffect, useState, useMemo } from "react";
import { NavLink, useParams } from "react-router-dom";
import styled from "@emotion/styled";
import {
  Box,
  TextField as MuiTextField,
  Button,
  Stack,
  Paper,
  Divider as MuiDivider,
  Container,
  Typography,
  Grid,
  Tabs,
  Tab,
  Card,
  CardContent,
} from "@mui/material";
import WidgetsIcon from "@mui/icons-material/Widgets";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Helmet } from "react-helmet-async";
import { spacing } from "@mui/system";
import PlayLessonIcon from "@mui/icons-material/PlayLesson";

import usePublishedProg from "hooks/usePublishedProg";
import BackBtn from "components/custom/BackBtn";
import useChallenge from "hooks/useChallenge";
import useReferentiel from "hooks/useReferentiel";
import TabPublishInfo from "./TabPublishInfo";
import TabPublishDayflow from "./TabPublishDayflow";
import TabThemesConfig from "./TabThemesConfig";
import TabBoostersConfig from "./TabBoostersConfig";
// ----------------------------------------------------------------------
const REF_MODEL = "programs";

const Divider = styled(MuiDivider)(spacing);
const TextField = styled(MuiTextField)(spacing);
const Item = styled(Paper)(({ theme }) => ({
  //backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));
export default function PublishProgDetailPage() {
  const [value, setValue] = React.useState(0);
  const { getStereotypeChallenges, getChallenges } = useChallenge();
  const { appPublishProg, isLoaded, initPublishProgById } = usePublishedProg();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const { id } = useParams();

  useEffect(() => {
    if (!id) return;
    initPublishProgById(id);
  }, [id]);
  if (Object.keys(appPublishProg).length === 0 && isLoaded)
    return <EmptyProgram />;
  if (Object.keys(appPublishProg).length === 0) return <></>;
  return (
    <>
      <Helmet title="Détail du programme publié" />
      <Box display="flex" justifyContent="justify-between" alignItems="center">
        <Button to="/app/publish-enable" component={NavLink}>
          <ArrowBackIosIcon />
          Retourner
        </Button>
        <Box sx={{ width: "100%" }}>
          <Tabs value={value} onChange={handleChange} centered>
            <Tab icon={<TipsAndUpdatesIcon />} label="Informations" />
            <Tab icon={<WidgetsIcon />} label="Configuration du programme" />
            <Tab icon={<PlayLessonIcon />} label="Boosters" />
          </Tabs>
        </Box>
      </Box>
      <Divider my={6} />

      {value === 0 && (
        <Card mb={6}>
          <CardContent>
            <TabPublishInfo editProgram={appPublishProg} />
          </CardContent>
        </Card>
      )}
      {value === 1 && <TabThemesConfig editProgram={appPublishProg} />}
      {value === 2 && <TabBoostersConfig editProgram={appPublishProg} />}
    </>
  );
}

const EmptyProgram = () => {
  const [display, setdisplay] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setdisplay(true);
    }, 2000);
    return () => {
      clearTimeout(timeout);
    };
  }, []);
  return (
    <Container>
      {display && (
        <>
          <Typography variant="h2" component="h3" gutterBottom>
            Le programme demandé n'est pas disponible.
          </Typography>
          <Box mb={8} />
          <Grid container spacing={6}>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Button
                component={NavLink}
                to="/app/publish-enable"
                variant="contained"
                color="primary"
              >
                <ArrowBackIosIcon />
                Retourner au catalogue
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </Container>
  );
};
